import { useEffect } from 'react'
import { useLottie } from 'lottie-react'

export interface LottieProps {
  data: string
  autoplay?: boolean
  loop?: boolean
  isVisible?: boolean
}

const style = {
  height: '100%',
  width: '100%',
}

const Lottie = ({ data, autoplay, loop, isVisible }: LottieProps) => {
  const animationData = JSON.parse(data)

  const options = {
    animationData: animationData ? animationData : {},
    autoplay: autoplay || isVisible ? true : false,
    loop: loop,
  }

  const { View, play } = useLottie(options, style)

  useEffect(() => {
    if (!autoplay && isVisible) {
      play()
    }
  }, [autoplay, isVisible, play])

  return View
}

export default Lottie
